import { render, staticRenderFns } from "./upload-doc.vue?vue&type=template&id=36c374b1&scoped=true"
import script from "./upload-doc.vue?vue&type=script&lang=js"
export * from "./upload-doc.vue?vue&type=script&lang=js"
import style0 from "./upload-doc.vue?vue&type=style&index=0&id=36c374b1&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c374b1",
  null
  
)

export default component.exports